import { PROMOS } from "../types";

export const PromosReducer = (state = [], action) => {
	const { type, payload } = action;

	switch (type) {
		case PROMOS: {
			const { data } = payload;
			state = [];
			return data;
		}
		default: {
			return state;
		}
	}
};
